var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMaternity(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/filled/uniq/check_maternity") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/filled/uniq/check_maternity",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_matanity",
    transform: "translate(9.000000, 1.000000)",
    fill: "#E67E22",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.85539978,7.20878651 C3.03390186,9.08796933 2.60680877,11.347169 2.60680877,11.347169 C2.60680877,11.347169 -1.11923164,13.8644092 0.338052509,19.4232187 L4.71691274,19.4232187 L5.36282013,24.6796745 C5.45563743,25.4357124 6.05516,26 6.76428041,26 L7.01165021,26 C7.79246925,26 8.42540986,25.3200372 8.42540986,24.4809572 L8.42540986,19.4232187 L9,19.4232187 C9,19.4232187 9,9.73376233 9,7.44397893 C9,5.64312527 6.52773215,5.48364934 4.85539978,7.20878651 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5000701,0 C6.11938345,0 5,1.11953901 5,2.5 C5,3.88083488 6.11938345,5 7.5000701,5 C8.88075676,5 10,3.88083488 10,2.5 C10,1.11953901 8.88075676,0 7.5000701,0 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMaternity);
export default __webpack_public_path__ + "static/media/ico_maternity.21250594cbc5ffd53aecc2e4ccbbf1d2.svg";
export { ForwardRef as ReactComponent };